export const selectProducts = state => state.items.items;
export const selectBoxCapacity = state => state.items.boxCapacity;
export const selectBoxes = state => state.items.boxes;